import { Drawer, IconButton, Box, Typography, useTheme, Collapse, SwipeableDrawer, Tooltip } from '@mui/material'
import { useLayoutContext } from '../../../../shared/contexts/layout.context'
import { useUserStore } from '../../../store/user.store'
import aliveLogo from '../../../../shared/assets/alivelogo.png'
import { Icons } from '../../../../shared/utils/icons.jsx'
import React, { useState } from 'react'

import { Link, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import CustomSwitch from '../../../../shared/components/common/CustomSwitch'

const menu = [
    { id: 1, active: true, view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/audit)\/?$/], permission: true, label: "Dashboard", children: null, link: `/audit`, icon: Icons.default.HomeIconOutlined, activeIcon: Icons.default.HomeIcon },
    { id: 15, active: true, view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/audit\/online-classes)\/?$/, /^(\/audit\/online-classes)\/list\/?$/, /^(\/audit\/online-classes)\/[\w-]+\/?$/], permission: true, label: "Online Classes", children: null, link: `/audit/online-classes`, icon: Icons.default.OndemandVideoIcon, activeIcon: Icons.default.MeetingRooms },
    { id: 11, active: true, view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/audit\/hybrid-classes)\/?$/, /^(\/audit\/hybrid-classes)\/list\/?$/, /^(\/audit\/hybrid-classes)\/[\w-]+\/?$/], permission: true, label: "Hybrid Classes", children: null, link: `/audit/hybrid-classes`, icon: Icons.default.HybridClasses, activeIcon: Icons.default.HybridClassesOutlined },
    { id: 12, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/meetings)\/?$/, /^(\/audit\/meetings)\/list\/?$/, /^(\/audit\/meetings)\/[\w-]+\/?$/], permission: true, label: "Meetings and Webinars", children: null, link: `/audit/meetings`, icon: Icons.default.MeetingRoomsOutlined, activeIcon: Icons.default.MeetingRooms },
    { id: 3, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/study-materials)\/?$/, /^(\/audit\/study-materials)\/list\/?$/], permission: true, label: "Study Material", children: null, link: `/audit/study-materials`, icon: Icons.default.DescriptionIconOutlined, activeIcon: Icons.default.DescriptionIcon },
    { id: 14, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/placement-training)\/?$/, /^(\/audit\/study-materials)\/list\/?$/], permission: true, label: "Placement Training", children: null, link: `/audit/placement-training`, icon: Icons.default.Business, activeIcon: Icons.default.Business },
    { id: 4, active: true, view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/audit\/assignments)\/?$/, /^(\/audit\/assignments)\/list\/?$/], permission: true, label: "Assignments", children: null, link: `/audit/assignments`, icon: Icons.default.AssignmentIconOutlined, activeIcon: Icons.default.AssignmentIcon },
    { id: 5, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/exams)\/?$/, /^(\/audit\/exams)\/list\/?$/], permission: true, label: "Exam", children: null, link: "/audit/exams", activeIcon: Icons.default.QuizIcon, icon: Icons.default.QuizIconOutlined },
    { id: 13, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/practice-with-simba)\/?$/, /^(\/audit\/practice-with-simba)\/list\/?$/], permission: true, label: "Practice Sessions", children: null, link: "/audit/practice-with-simba", activeIcon: Icons.default.Checklist, icon: Icons.default.Checklist },
    { id: 6, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/quizzes)\/?$/, /^(\/audit\/quizzes)\/list\/?$/], permission: true, label: "Quizzes", children: null, link: "/audit/quizzes", activeIcon: Icons.default.PsychologyAlt, icon: Icons.default.PsychologyAltOutlined },
    { id: 7, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/questionbanks)\/?$/, /^(\/audit\/questionbanks)\/list\/?$/], permission: true, label: "Question Banks", children: null, link: "/audit/questionbanks", activeIcon: Icons.default.QuestionMark, icon: Icons.default.QuestionMarkOutlined },
    { id: 8, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/class-sessions)\/?$/, /^(\/audit\/class-sessions)\/list\/?$/], permission: true, label: "Class Sessions", children: null, link: "/audit/class-sessions", activeIcon: Icons.default.EmojiPeopleIcon, icon: Icons.default.EmojiPeopleIconOutlined },
    { id: 9, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/discussions)\/?$/, /^(\/audit\/discussions)\/list\/?$/], permission: ["PRINCIPAL", "ADMIN", "SUBADMIN", "is_auditor"], label: "Discussions", children: null, link: "/audit/discussions", activeIcon: Icons.default.Discussions, icon: Icons.default.DiscussionsOutlined },
    { id: 16, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/placements-tracker)\/?$/, /^(\/audit\/placements-tracker\/students)\/?$/, /^(\/audit\/placements-tracker\/jobs)\/?$/, /^(\/audit\/placements-tracker\/jobs\/[\w-]+)\/?$/], permission: true, label: "Placements Tracker", children: null, link: "/audit/placements-tracker", activeIcon: Icons.default.Work, icon: Icons.default.WorkOutline },
    { id: 10, active: false, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/faculty\/\w+)\/?$/], permission: true, label: "Faculty Audit", children: null, link: "", activeIcon: Icons.default.PeopleAltIcon, icon: Icons.default.PeopleAltIcon },
]

const closedSidebarWidth = 60

const SidedrawerMenuItem = ( { item, isActive, closeOnMobileScreen, active } ) => {

    const { isSideDrawerCollapsed } = useLayoutContext()
    const [collapseState, setCollapseState] = useState( false )
    const { palette, layout } = useTheme()
    return (
        <Box sx={{ borderRadius: layout.borderRadius, bgcolor: collapseState && palette.nav.sidebarHover }}>
            <Tooltip placement='right' enterDelay={0} disableInteractive arrow title={isSideDrawerCollapsed ? item.label : ''}>
                <Box
                    role="link"
                    component={Link}
                    className='default-link'
                    target={item.target}
                    to={!item.children ? typeof item.link === 'string' ? item.link : item.link() : `#${item.label}`}
                    onClick={item.children ? () => setCollapseState( !collapseState ) : closeOnMobileScreen}
                    sx={{
                        color: isActive ? palette.nav.activeFont : palette.nav.font,
                        borderRadius: layout.borderRadius,
                        display: 'flex',
                        alignItems: 'center',
                        padding: 1,
                        paddingY: 0.5,
                        gap: '15px',
                        marginY: '2px',
                        minWidth: closedSidebarWidth - 20,
                        cursor: 'pointer',
                        position: 'relative',
                        background: isActive ? palette.nav.activeSidebarItem : 'none',
                        '&:hover': {
                            background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem,
                        },
                    }}
                >
                    <Typography sx={{ color: 'inherit', borderRadius: layout.borderRadius, padding: '2px', position: 'relative', fontSize: '18px', display: 'flex', alignItems: 'center' }}>
                        {item.icon}
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0, color: 'inherit', fontWeight: isActive ? '500' : '300', fontSize: '14px', textAlign: 'center' }}>
                        <Typography noWrap sx={{ opacity: isSideDrawerCollapsed ? 0 : 1, fontSize: '14px', color: 'inherit' }}>
                            {item.label}
                        </Typography>
                        {item.children ? Icons.small.KeyboardArrowDown : item.secondaryIcon || ''}
                    </Box>
                </Box>
            </Tooltip>
            {item.children && <Collapse in={collapseState}>
                <Box
                    sx={{
                        flexDirection: "column",
                        paddingBottom: "10px",
                        display: "flex",
                        gap: "5px",
                        paddingRight: "20px",
                        paddingLeft: "30px"
                    }}>
                    {item.children.map( ( sublink, index ) => {
                        const activeChild = item.activeMatchRegexes[index].some( re => active.match( re ) )
                        return (
                            <Link className='default-link' key={sublink} to={item.link[index]}>
                                <Box
                                    onClick={closeOnMobileScreen}
                                    sx={{
                                        display: "flex",
                                        borderRadius: layout.borderRadius,
                                        padding: "2px 5px",
                                        gap: "20px",
                                        alignItems: "center",
                                        color: activeChild ? palette.nav.activeFont : palette.nav.font,
                                        cursor: "pointer",
                                        position: "relative",

                                        "&::before": {
                                            display: activeChild ? "inline-block" : "none",
                                            content: "''",
                                            position: "absolute",
                                            background: "#fff",
                                            height: "60%",
                                            borderRadius: "0 2px 2px 0",
                                            left: 0,
                                            width: "2px",
                                            zIndex: 324434,
                                            top: "50%",
                                            transform: "translate(0,-50%)"
                                        },

                                        "&:hover": {
                                            textDecoration: "underline",
                                        }
                                    }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            flexShrink: 0,
                                            color: "inherit",
                                            fontWeight: activeChild ? "400" : "300",
                                            fontSize: "14px",
                                            textAlign: "center"
                                        }}>{sublink}</Typography>
                                </Box>
                            </Link>
                        )
                    } )}
                </Box>
            </Collapse>}
        </Box>
    )
}

const SideDrawer = function () {
    const { sidebarOpenState, setNavHeadText, active, setMenuState, menuState, sidebarWidth, minSidebarCollapseWidth, setIsSideDrawerCollapsed, isSideDrawerCollapsed } = useLayoutContext()
    console.log( { active } )


    const { palette, shadows, border, layout } = useTheme()

    const UserStore = useUserStore()
    const navigate = useNavigate()

    const closeOnMobileScreen = () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            setMenuState( false )
    }

    const toggleAuditMode = () => {
        if ( active.includes( '/audit' ) ) {
            let redirect = localStorage.getItem( 'audit_redirect' )
            if ( !redirect )
                redirect = ["ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) ? `/admin/home` : `/faculty/home`
            navigate( redirect )
        } else {
            localStorage.setItem( 'audit_redirect', `${active}${window.location.search}` )
            navigate( '/audit/' )
        }
        setMenuState( false )
    }

    useEffect( () => {
        for ( let i = 0; i < menu.length; i++ ) {
            const item = menu[i]
            const isActive = item.activeMatchRegexes.flat().some( re => active.match( re ) )
            if ( isActive ) {
                setNavHeadText( item.label )
                break
            }
        }
    }, [active, setNavHeadText] )

    return (
        <Box>
            <Box sx={{
                display: { sm: "block", xs: "none" }
            }}>
                <Drawer
                    variant='persistent'
                    anchor='left'
                    open={true}
                    className='no-scrollbar'
                    slotProps={{
                        paper: {
                            className: 'no-scrollbar',
                            sx: {
                                width: !isSideDrawerCollapsed ? sidebarWidth : closedSidebarWidth,
                                borderRadius: "0",
                                background: palette.nav.sidebar,
                                borderRight: "none",
                                transition: "200ms",
                                overflowX: "hidden"
                            }
                        },
                    }}
                    sx={{
                        background: 'transparent',
                        position: 'initial',
                        overflow: 'hidden',
                        width: !isSideDrawerCollapsed ? sidebarWidth : closedSidebarWidth,
                        height: '100%',
                        flexSrink: 0,
                        display: { sm: 'flex', xs: 'none' },
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            flexGrow: 1,
                            overflow: "auto",
                            display: "flex"
                        }}>
                        <Box
                            className='sidebar-scrollbar'
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                overflowX: 'clip',
                                overflowY: 'auto',
                                color: 'GrayText',
                                alignItems: 'stretch',
                            }}>
                            <Box
                                sx={{
                                    mb: 2,
                                    display: "flex",
                                    gap: "10px",
                                    padding: "8px 15px",
                                    alignItems: "center"
                                }}>
                                <Box
                                    sx={{
                                        padding: "5px 7px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: layout.borderRadius,
                                        bgcolor: "white",
                                        aspectRatio: "1 / 1"
                                    }}><Box component="img" src={aliveLogo} alt="Logo" sx={{
                                        width: "20px"
                                    }} /></Box>
                                <Box sx={{ opacity: isSideDrawerCollapsed ? 0 : 1 }}>
                                    <Typography color={palette.nav.font} noWrap variant='h6' sx={{
                                        fontSize: "14px"
                                    }}>Alive</Typography>
                                    <Typography
                                        color={palette.nav.font}
                                        noWrap
                                        variant='body2'
                                        sx={{
                                            fontSize: "12px",
                                            fontWeight: "300"
                                        }}>Acharya LMS platform</Typography>
                                </Box>
                                <IconButton sx={{ color: palette.nav.font, display: { sm: "none", xs: "block" } }} onClick={() => setMenuState( false )}>
                                    {Icons.default.CloseIcon}
                                </IconButton>
                            </Box>
                            <Box
                                className='sidebar-scrollbar'
                                sx={{
                                    padding: '0 10px 20px 10px',
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    overflowY: 'auto',
                                    overflowX: 'clip',
                                }}
                            >
                                {menu.filter(
                                    item => item.active && ( ( typeof item.permission === 'boolean' && item.permission ) || ( Array.isArray( item.permission ) && ( item.permission.includes( UserStore.getUser.user_role ) || ( item.permission.includes( 'is_auditor' ) && UserStore.getUser.is_auditor ) ) ) )
                                ).map( item => {
                                    const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )

                                    return (
                                        <SidedrawerMenuItem active={active} closeOnMobileScreen={closeOnMobileScreen} item={item} isActive={isActive} sidebarOpenState={sidebarOpenState} key={item.id} />
                                    )
                                } )}
                                <Box sx={{ flexGrow: 1 }} />
                                <Box
                                    id="audit-collapse-sidebar"
                                    onClick={() => setIsSideDrawerCollapsed( prev => !prev )}
                                    sx={{
                                        color: palette.nav.font,
                                        borderRadius: layout.borderRadius,
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: 1,
                                        paddingY: 0.5,
                                        gap: '15px',
                                        marginY: '2px',
                                        minWidth: closedSidebarWidth - 20,
                                        cursor: 'pointer',
                                        position: 'relative',
                                        '&:hover': { background: palette.nav.sidebarItemHoverBg },
                                    }}
                                >
                                    <Tooltip placement='right' enterDelay={0} disableInteractive arrow title={isSideDrawerCollapsed ? 'Expand Sidebar' : ''}>
                                        <IconButton color='inherit' disableFocusRipple disableRipple disableTouchRipple sx={{ padding: '2px', borderRadius: layout.borderRadius, transform: 'scale(0.9)', position: 'relative', fontSize: '18px' }}>
                                            {!isSideDrawerCollapsed ? Icons.default.MenuClose : Icons.default.ChevronRightIcon}
                                        </IconButton>
                                    </Tooltip>
                                    <Typography noWrap sx={{ opacity: isSideDrawerCollapsed ? 0 : 1, fontSize: '0.875rem' }}>Collapse Sidebar</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box >
                </Drawer >
            </Box>
            <Box sx={{
                display: { sm: "none", xs: "block" }
            }}>
                <Box
                    sx={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        padding: "10px 20px",
                        background: palette.layoutBackground
                    }}>
                    {menu.filter( item => item.active && item.view.includes( "bleeding-bottom-bar" ) ).map( item => {
                        const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                        return (
                            <Box key={item.id}>
                                <Link to={item.link} className='default-link' >
                                    <Box
                                        sx={{
                                            color: isActive ? palette.primary.main : palette.text.secondary,
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            gap: "5px"
                                        }}>
                                        <Box sx={{ fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center" }}>{item.icon}</Box>
                                        <Typography
                                            color={isActive ? palette.nav.activeSidebarItem : palette.text.secondary}
                                            sx={{
                                                fontSize: "12px",
                                                textAlign: "center"
                                            }}>{item.label}</Typography>
                                    </Box>
                                </Link>
                            </Box>
                        )
                    } )}
                    <Box
                        onClick={() => setMenuState( true )}
                        sx={{
                            color: palette.nav.font,
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "5px",
                            cursor: "pointer"
                        }}>
                        <Box
                            sx={{
                                fontSize: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>{Icons.default.Menu}</Box>
                        <Typography
                            color={palette.nav.font}
                            sx={{
                                fontSize: "12px",
                                textAlign: "center"
                            }}>More</Typography>
                    </Box>
                </Box>
                <SwipeableDrawer
                    sx={{ background: "transparent", zIndex: { sm: "initial", xs: "120000" }, overflow: "hidden", width: menuState ? sidebarWidth : 0, flexShrink: 0, display: { xs: "flex", sm: "none" }, flexDirection: "column" }}
                    anchor="bottom"
                    open={menuState}
                    className="no-scrollbar"
                    keepMounted={false}
                    swipeAreaWidth={0}
                    onClose={() => setMenuState( false )}
                    onOpen={() => setMenuState( true )}
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { borderRadius: `${layout.borderRadius * 4}px ${layout.borderRadius * 4}px 0 0`, background: palette.nav.sidebar, borderRight: "none", maxHeight: "80%" } }
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            flexGrow: 1,
                            overflow: "auto"
                        }}>
                        {( ["PRINCIPAL", "HOD", "ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) || UserStore.getUser.user_auditor ) && <Box
                            onClick={toggleAuditMode}
                            sx={{
                                display: { xs: "flex", md: "none" },
                                gap: "10px",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "10px",
                                margin: "20px",
                                padding: "5px 10px",
                                boxShadow: shadows[1],
                                bgcolor: palette.contentBg,
                                border: border[1],
                                borderRadius: layout.borderRadius,
                                cursor: "pointer"
                            }}>
                            <Typography color={palette.common.font} variant="subtitle2" sx={{
                                fontSize: "12px"
                            }}>Audit Mode</Typography>
                            <CustomSwitch size="small" checked={active.startsWith( '/audit' )} onChange={toggleAuditMode} />
                        </Box>}
                        <Box
                            className="sidebar-scrollbar"
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3,1fr)",
                                padding: "40px 20px",
                                flexWrap: "wrap",
                                width: "100%",
                                gap: "30px",
                                justifyContent: "space-evenly",
                                overflow: "auto",
                                color: "GrayText",
                                alignItems: "stretch",
                                overflowX: "clip"
                            }}>
                            {menu.filter( item => item.active && item.view.includes( "opened-bottom-bar" ) ).map( item => {
                                const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                return (
                                    <Box key={item.id}>
                                        <Link to={item.link} className='default-link' >
                                            <Box
                                                sx={{
                                                    color: isActive ? palette.nav.activeSidebarItem : palette.text.secondary,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    gap: "5px"
                                                }}>
                                                <Box sx={{ fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center" }}>{item.icon}</Box>
                                                <Typography
                                                    color={isActive ? palette.nav.activeSidebarItem : palette.text.secondary}
                                                    sx={{
                                                        fontSize: "12px",
                                                        textAlign: "center"
                                                    }}>{item.label}</Typography>
                                            </Box>
                                        </Link>
                                    </Box>
                                )
                            } )}
                        </Box>
                    </Box >
                </SwipeableDrawer >
            </Box>
        </Box >
    )
}

export default SideDrawer


